<template>
  <div class="edit-entity">
    <Dropdown
      fullwidth
      :label="value.name ?? 'Select a Prospect or Client'"
    >
      <AutocompleteWithFetch
        v-slot="{ item }"
        endpoint="/api/v1/prospects"
        results-field="prospects"
        :multiple="false"
        @selection-change="handleSelectionChange"
      >
        <p>{{ item.name }}</p>
      </AutocompleteWithFetch>
    </Dropdown>
  </div>
</template>

<script setup>
import AutocompleteWithFetch from '@frontend/ui/components/utils/AutocompleteWithFetch.vue';
import Dropdown from '../dropdown/Dropdown.vue';

defineProps({
  value: {
    type: [Object, String],
    required: false,
    default: () => ({}),
  },
});

const emit = defineEmits(['input']);

function handleSelectionChange(newValue) {
  emit('input', newValue[0]);
}
</script>
